if(getShoptetDataLayer('customer').groupId == null){
    $('.login-close').remove()
    $('.user-action-login.login-widget').css('display', 'block')
}